import React from 'react';
import {useTranslation} from 'react-i18next';
import {inAnteprima} from '../../skin';
import {indirizzoImmagine} from '../../utils/immagini';
import Nota from './Nota';

/**
 * APPROVATO DA (blocco «fiducia» della Home): una striscia coi loghi di chi
 * garantisce il sito (ente della licenza, sigillo, verifica, pagamenti),
 * ognuno con la sua didascalia e, se scritto, un collegamento che si apre
 * in una scheda nuova (e' quasi sempre un sito esterno).
 *
 * I loghi si caricano dal backoffice (Moduli › Home › Approvato da): qui
 * non ce n'e' nessuno di serie, perche' un sigillo che non si ha e' una
 * bugia. Senza loghi, tre posti vuoti che vede solo chi compone la skin.
 */
export default function Fiducia({titolo, loghi}) {
  const {t} = useTranslation();
  const intestazione = String(titolo || '').trim() || t('Approvato da');
  const voci = (Array.isArray(loghi) ? loghi : [])
      .filter((l) => l && (String(l.indirizzo || '').trim() || String(l.nome || '').trim()))
      .map((l) => ({immagine: String(l.indirizzo || '').trim(), nome: String(l.nome || '').trim(), dove: String(l.collegamento || '').trim()}));
  if (!voci.length) {
    if (!inAnteprima()) return null;
    return (
      <section className={'vet-blocco vet-fiducia'} aria-label={intestazione}>
        <div className={'vet-fiducia-riga'}>
          <span className={'vet-fiducia-titolo'}>{intestazione}</span>
          {[0, 1, 2].map((i) => <span key={i} className={'vet-fiducia-logo vuoto'} aria-hidden={'true'}/>)}
        </div>
        <Nota tono={'spento'} etichetta={t('da caricare')}>
          {t('I loghi di chi garantisce il sito si caricano dal backoffice (Moduli › Home › Approvato da). Oggi non ce n’è nessuno: si vedono tre posti vuoti, non un sigillo inventato.')}
        </Nota>
      </section>
    );
  }
  const logo = (v) => (
    <>
      {v.immagine ? <img src={indirizzoImmagine(v.immagine)} alt={v.nome}/> : <b>{v.nome}</b>}
      {v.immagine && v.nome && <small>{v.nome}</small>}
    </>
  );
  return (
    <section className={'vet-blocco vet-fiducia'} aria-label={intestazione}>
      <ul className={'vet-fiducia-riga'}>
        <li className={'vet-fiducia-titolo'}>{intestazione}</li>
        {voci.map((v, i) => (
          <li key={i}>
            {v.dove
              ? <a className={'vet-fiducia-logo'} href={v.dove} target={'_blank'} rel={'noopener noreferrer'}>{logo(v)}</a>
              : <span className={'vet-fiducia-logo'}>{logo(v)}</span>}
          </li>
        ))}
      </ul>
    </section>
  );
}
